(() => {
  function initDiscountScript() {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) return;

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    function clearMessages() {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    function showError(msg) {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = msg;
      }
    }

    function getCurrentDiscounts() {
      const pills = document.querySelectorAll('#applied-discounts .discount-pill');
      return Array.from(pills).map((pill) => pill.getAttribute('data-code').toUpperCase());
    }

    function triggerCartUpdate() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Drawer-quantity-1') ||
          document.getElementById('Quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartDrawerItems.updateQuantity(1, currentQty);
          return;
        } else {
          cartDrawerItems.onCartUpdate();
          return;
        }
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Quantity-1') ||
          document.getElementById('Drawer-quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartItems.updateQuantity(1, currentQty);
          return;
        } else {
          cartItems.onCartUpdate();
          return;
        }
      }
    }

    async function applyDiscounts(discountCodes = []) {
      let isRemoving = false;
      if (discountCodes.length === 0) {
        isRemoving = true;
      }
      const discountString = discountCodes.join(',');

      let cartData = null;
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountString })
        });
        cartData = await res.json();
      } catch (err) {
        return { success: false, invalidCodes: discountCodes.slice(-1) };
      }

      const codeState = {};
      (cartData.discount_codes || []).forEach(function (d) {
        if (d && d.code) codeState[d.code.toUpperCase()] = d.applicable;
      });

      const invalidCodes = discountCodes.filter(function (c) {
        return codeState[c.toUpperCase()] === false;
      });
      const newlyAddedCode = discountCodes[discountCodes.length - 1];
      const codeIsInvalid = invalidCodes.includes(newlyAddedCode);

      if (!codeIsInvalid || isRemoving) { triggerCartUpdate(); }

      return {
        success: !codeIsInvalid || isRemoving,
        invalidCodes
      };
    }

    applyBtn.addEventListener('click', async () => {
      clearMessages();
      const existingCodes = getCurrentDiscounts();
      let newCode = discountInput.value.trim().toUpperCase();
      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }
      if (existingCodes.includes(newCode)) {
        showError(MSG_ALREADY_APPLIED);
        return;
      }
      const combinedCodes = [...existingCodes, newCode];
      const result = await applyDiscounts(combinedCodes);
      if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
        showError(MSG_INVALID);
      }
    });

    appliedDiscountsContainer.addEventListener('click', async (event) => {
      if (!event.target.closest('.remove-discount')) return;
      clearMessages();
      const pill = event.target.closest('.discount-pill');
      if (!pill) return;
      const codeToRemove = pill.getAttribute('data-code');
      if (!codeToRemove) return;
      const existingCodes = getCurrentDiscounts();
      const newDiscountList = existingCodes.filter(c => c !== codeToRemove.toUpperCase());
      await applyDiscounts(newDiscountList);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDiscountScript();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
    });
  }
})();
